module.exports = __webpack_public_path__ + "img/graphics.426417f3.png";